/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { SessionService } from '../services/session2.service';
import { CacheService } from '../global/ng2-cache/services/cache.service';
import { EnrichService } from '../services/enrich.service';
import { WorkflowService } from '../services/workflow.service';
import { EloquaCdoService } from '../services/eloqua-cdo.service';
import { AutomateJobService } from '../services/automate-job.service';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html'
})
export class ConfigComponent implements OnInit {

  loadingPage: boolean = true;
  session: any;

  syncs: any = null;
  workflows: Array<any> = [];
  workflowCount: any = {
    n: 0,
    e: 0,
    a: 0
  };

  cdoCount: any = {
    n: 0,
    e: 0
  };

  syncType: any = {
    phone: 1,
    title: 1
  };

  routeTrackCount: number = 0;

  constructor(private sessionService: SessionService,
    private cacheService: CacheService,
    private enrichService: EnrichService,
    private workflowService: WorkflowService,
    private automateJobService: AutomateJobService,
    private eloquaCdoService:EloquaCdoService) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          // if (!session.f.enrich) {
          //   this.router.navigate(['/config/workflows']);
          // }
          // else {
          //   this.session = session;
          //   this.initView();
          // }
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      // if (!this.session.f.enrich) {
      //   this.router.navigate(['/config/workflows']);
      // }
      // else {
      //   this.initView();
      // }
      this.initView();
    }
  }

  private initView() {
    this.loadingPage = true;
    Observable.forkJoin(
      this.enrichService.getSyncs(),
      this.workflowService.getWorkflows(),
      this.eloquaCdoService.getSyncs(),
      this.automateJobService.getJobs('routetrack')
    ).subscribe((result: any) => {
      this.syncs = result[0].length > 0 ? result[0][0] : null;
      result[1].forEach((wf) => {
        if (wf.enabled) {
          if (wf.trigger.data == 'contacts') {
            this.workflowCount.n++;
          }
          else if (wf.trigger.data == 'recipient') {
            this.workflowCount.e++;
          }
          else {
            this.workflowCount.a++;
          }
        }
      });

      result[2].forEach((cdo) => {
        if (cdo.enabled) {
          if (cdo.trigger.data == 'contacts') {
            this.cdoCount.n++;
          }
          else if (cdo.trigger.data == 'recipient') {
            this.cdoCount.e++;
          }
        }
      });

      result[3].forEach(routeTrack => {
        if (routeTrack.enabled) {
          this.routeTrackCount++;
        }
      });

      this.workflows = result[1];
      this.loadingPage = false;
    }, error => {

    });
  }
}



// WEBPACK FOOTER //
// ./client/app/config/config.component.ts